<script>
import { mapGetters } from 'vuex';

export default {
    name: 'SiteHeader',
    data: () => {
        return {
            menuIsOpen: false,
            currentScrollY: 0,
        }
    },
    mounted() { },
    methods: {
        toggleMenu() {
            this.menuIsOpen = !this.menuIsOpen;
        },
        closeMenu() {
            this.menuIsOpen = false;
        },
        onInfoClick(event, slug) {
            event.preventDefault();
            this.$store.dispatch('openOverlayPage', { 
                component: 'InfoPage',
                props: { 
                    slug: slug
                }
            });
            this.closeMenu();
        },
    },
    computed: {
        ...mapGetters({
            siteHeaderMode: 'getSiteHeaderMode',
            mainNavData: 'getMainNav',
            footerFooterData: 'getFooterNav',
            isLoading: 'getMainNavIsLoading',
        }),
    },
    watch: {
        '$route' () {
            this.closeMenu();
        }
    }
};
</script>

<template>
    <header class="site-header" v-bind:class="['site-header--' + siteHeaderMode]">
        <router-link to="/">
            <img src="../assets/images/logo-leben-mit-schizophrenie.svg" alt="Logo Leben mit Schizophrenie" class="site-header__logo">
        </router-link>

        <div class="site-header__nav" v-bind:class="{ 'site-header__nav--open': menuIsOpen }" v-if="!isLoading">
            <transition name="scale">
                <div class="site-header__nav__background" v-if="menuIsOpen"></div>
            </transition>
            <ul class="site-header__main-nav">
                <li class="site-header__main-nav__item" v-for="(item, i) in mainNavData" v-bind:key="i">
                    
                    <router-link 
                        v-if="item.exceptional_case === 'question-page'"
                        v-bind:to="'/fragen-antworten'" 
                        class="site-header__main-nav__link" 
                        v-html="item.title">
                    </router-link>

                    <a  v-else-if="item.exceptional_case === 'info-page'"
                        href="#" 
                        class="site-header__main-nav__link site-header__main-nav__link--info"
                        v-on:click="onInfoClick($event, item.slug)"
                        v-html="item.title">
                    </a>

                    <router-link 
                        v-else
                        v-bind:to="'/' + item.slug" 
                        class="site-header__main-nav__link"
                        v-bind:class="`site-header__main-nav__link--${item.exceptional_case}`"
                        v-html="item.title">
                    </router-link>

                </li>
            </ul>

            <ul class="site-header__footer-nav">
                <li class="site-header__footer-nav__item" v-for="item in footerFooterData" v-bind:key="item.id">
                    <router-link 
                        v-bind:to="'/' + item.slug" 
                        class="site-header__footer-nav__link" 
                        v-html="item.title">
                    </router-link>
                </li>
            </ul>
        </div>

        <button class="site-header__main-nav__button" v-bind:class="{'site-header__main-nav__button--open': menuIsOpen}" v-on:click="toggleMenu">
            <span v-if="!menuIsOpen">Menü</span>
            <span v-if="menuIsOpen">Schliessen</span>
        </button>

    </header>
</template>

<style lang="scss" scoped>
.site-header {
    display: flex;
    box-sizing: border-box;
    width: 100%;
    padding: 3rem 5rem;
    flex-direction: row;
    justify-content: space-between;
    transition: background-color 200ms linear;

    @include breakpoint('md-down') {
        background-position: -112rem -32rem;
    }

    @include breakpoint("md-down") {
        padding: 2.55rem 4.25rem;
    }

    @include breakpoint("sm-down") {
        padding: 2.2rem 3rem;
    }

    @include breakpoint("xs-down") {
        padding: 1rem 2rem;
        background-position: -120rem -32rem;
    }
}
.site-header--opaque {
    background-color: $color-light;
}
.site-header__logo {
    @include breakpoint("xs-down") {
        width: 14.88rem
    }
}
.site-header__nav {
    @include breakpoint("sm-down") {
        position: fixed;
        display: none;
        top: 0; right: 0; bottom: 0; left: 0;
        flex-direction: column;
        justify-content: flex-end;
        box-sizing: border-box;
        padding: 1.44rem 1.76rem;
        margin: 0;
    }
}
.site-header__nav--open {
    display: flex;
}
.site-header__nav__background {
    display: none;
    position: absolute;
    display: none;
    top: 0; right: 0; bottom: 0; left: 0;
    background: rgba($color-primary, .95);
    z-index: -1;

    @include breakpoint("sm-down") {
        display: block;
    }
}
.site-header__main-nav {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 1.12rem 0;
    margin: 0 -1.6rem;

    @include breakpoint("sm-down") {
        display: block;
        margin: 0;
        padding: 0;
    }
}
.site-header__footer-nav {
    margin-top: 1.6rem;
    padding: 0;
    opacity: .5;
}
.site-header__main-nav__item,
.site-header__footer-nav__item {
    display: block;
    margin: 0 1.6rem;
    font-size: 1.7rem;
    letter-spacing: 0.08em;
    text-align: right;
    text-transform: uppercase;

    @include breakpoint("md-down") {
        margin: 0 1.2rem;
        max-width: 32rem;
    }

    @include breakpoint("sm-down") {
        max-width: none;
        margin: 2.24rem 0;
        font-size: 2.08rem;
        text-align: center;
    }
}
.site-header__footer-nav__item {
    margin: 0.64rem 0;
}

.site-header__main-nav__link {
    color: $color-secondary;
    text-decoration: none;
    padding-bottom: 0.96rem;
    border-bottom: 0.1rem solid transparent;
    white-space: nowrap;

    @include breakpoint("sm-down") {
        padding-bottom: 0.48rem;
        color: $color-light;
        white-space: normal;
        font-weight: 700;
        font-size: 3.2rem;
        line-height: 1;
    }
}
.site-header__main-nav__link--consulting-page::before {
    content: '';
    display: inline-block;
    width: 3.7rem;
    height: 3.5rem;
    vertical-align: middle;
    margin-right: 1.2rem;
    background-image: url('~@/assets/images/logo-consulting.svg');
    background-size: 100%;
    background-repeat: no-repeat;

    @include breakpoint('md-down') {
        content: none;
    }
}
.site-header__footer-nav__link {
    font-weight: 300;
    font-size: 2rem;
    line-height: 1;
    text-decoration: none;
    color: $color-light;
}
.router-link-active {
    border-color: rgba($color-secondary, .5);

    @include breakpoint("sm-down") {
        border-color: transparent;
    }
}
.site-header__main-nav__button {
    display: block;
    margin: 0 1.6rem;
    color: $color-secondary;
    font-size: 1.7rem;
    letter-spacing: 0.08em;
    text-align: right;
    text-transform: uppercase;
    margin: 0;
    padding: 0;
    border: none;
    outline: none;
    background: transparent;
    z-index: 1;

    @include breakpoint("md-up") {
        display: none;
    }
}
.site-header__main-nav__button--open {
    color: $color-light;
}

.site-header__main-nav__link--info {
    @include breakpoint("md-up") {
        display: block;
        width: 2.08rem; height: 1.28rem;
        font-size: 0;
        background: center url('~@/assets/images/ico-info.svg') no-repeat;
    }
}

.site-header__footer-nav__item {
    @include breakpoint("md-up") {
        display: none;
    }
}

.scale-enter-active, .scale-leave-active {
    transition: 
        transform 200ms cubic-bezier(0.23, 1, 0.32, 1),
        opacity 300ms linear;
}
.scale-enter, .scale-leave-to {
    transform: scale(0);
    opacity: 0;
}
</style>
